import React from "react";
import PaymentMethods from "../PaymentMethods";

const PaymentSection = ({ studentNumber, showPaymentMethods }) => {
  if (!showPaymentMethods) {
    return null;
  }

  return <PaymentMethods studentNumber={studentNumber} />;
};

export default PaymentSection;

